
const OldAnimations = () => {
  const ctaButtons = document.querySelectorAll(".c-download-btn");

  if (ctaButtons.length === 0) {
    return;
  }

  const handleScroll = () => {
    const isScrolled = window.scrollY > 100;
    ctaButtons.forEach(button => {
      button.classList.toggle('is-show', isScrolled);
    });
  };

  window.addEventListener('scroll', handleScroll, { passive: true });
};


export {OldAnimations}
